import classnames from 'classnames';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { Card, Col, Container, Input, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import baseUrl from '../../helpers/baseurl';
// actions
import { BackButton } from '../../components/Common/BackButton';
import Breadcrumb from '../../components/Common/Breadcrumb';
import Table1 from '../../components/Common/TableContainer';
import { diffDays, getBusinessDateCountString } from '../../helpers/mixFunctions';
import { getCoordinations } from '../../store/catalogs/Coordinations/actions';
import { getLabAreas } from '../../store/catalogs/LabAreas/actions';
import { getLabs } from '../../store/catalogs/Laboratories/actions';
import { getLabSegments } from '../../store/catalogs/LabSegments/actions';
import { getUsers } from '../../store/catalogs/Users/actions';
import { updateLabRequest } from '../../store/labCitec/labRequest/actions';
import { getLabRequestReportRois } from '../../store/labCitec/labRequestReportsRoi/actions';
import { UModal } from './regverModal';
import { BaseCustomButton, GradientDecorationLine, BaseCustomModal } from '../../shared';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE } from '../../constants/tables';

export const Results = (props) => {
    //Modal hooks
    const [showModal1, setShowModal1] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    //Filter hooks
    const [labAreaFilter, setLabAreaFilter] = useState('');
    const [labTypeFilter, setLabTypeFilter] = useState('');
    const [coordFilter, setCoordFiler] = useState('');
    const [initialDate, setInitialDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [dateFilter, setDateFilter] = useState('');
    const [serviceFilter, setServiceFilter] = useState('');

    const citec = localStorage?.getItem("CITEC") ? JSON.parse(localStorage?.getItem("CITEC") ?? `{"labType": '1' }`) : '0'
    const movil = localStorage?.getItem("Movil") ? JSON.parse(localStorage?.getItem("Movil") ?? `{"lId": '1' }`) : '0'

    const [params2, setParams2] = useState(`?limit=${DEFAULT_PAGE_SIZE}&page=${DEFAULT_PAGE}`);
    const [ pageSizeCitec, setPageSizeCitec ] = useState(DEFAULT_PAGE_SIZE)
    const [ pageSizeMovil, setPageSizeMovil ] = useState(DEFAULT_PAGE_SIZE)

    let [queryParam, setQueryParam] = useState('');
    let [ filterQuery, setFilterQuery ] = useState('');
    let [excelQueryParam, setExcelQueryParam] = useState('');

    // Tab Hook
    let [activeTab, setActiveTab] = useState('1');
    const dispatch = useDispatch();

    const applyFiltersAndFetch = (pageSize, labTypeId, reset = false) => {
        
        if (reset) {
            setCoordFiler('');
            setLabAreaFilter('');
            setLabTypeFilter('');
            setInitialDate('');
            setEndDate('');
            setDateFilter('');
            setServiceFilter('');
            setParams2(`?limit=${DEFAULT_PAGE_SIZE}&page=${DEFAULT_PAGE}`);
            setFilterQuery('');
            setExcelQueryParam('');
            setQueryParam('');
            setPageSizeCitec(DEFAULT_PAGE_SIZE);
            setPageSizeMovil(DEFAULT_PAGE_SIZE);
        }

        const newParams = `?limit=${pageSize}&page=${DEFAULT_PAGE}`;
        const query = buildQueryParams({
            labArea: labAreaFilter,
            labType: labTypeFilter,
            coord: coordFilter,
            dateFilter,
            initialDate,
            endDate,
            service: serviceFilter,
        });

        setFilterQuery(query);
        const fullQuery = `?limit=${activeTab === '1' ? pageSizeCitec : pageSizeMovil}&page=${DEFAULT_PAGE}&reportType=results&laboratoryType=${labTypeId}${query}`;
        setQueryParam(fullQuery);
        setExcelQueryParam(fullQuery);
        setParams2(newParams);
        dispatch(getLabRequestReportRois(fullQuery));
    };

    const profiletoggle = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            const size = tab === '1' ? pageSizeCitec : pageSizeMovil;
            const id = tab === '1' ? citec : movil;
            applyFiltersAndFetch(size, id, true);
        }
    }

    useEffect(() => {
        dispatch(getCoordinations(`?limit=100&page=${DEFAULT_PAGE}`));
        dispatch(getLabSegments(`?limit=100&page=${DEFAULT_PAGE}`));
        dispatch(getUsers(`?limit=100&page=${DEFAULT_PAGE}`));

        if (activeTab === '2') {
            dispatch(getLabAreas(`?limit=100&page=${DEFAULT_PAGE}&search=Móvil`));
            dispatch(getLabs(`?limit=100&page=${DEFAULT_PAGE}&search=Móvil`));
            applyFiltersAndFetch(pageSizeMovil, movil);
        } else {
            dispatch(getLabAreas(`?limit=100&page=${DEFAULT_PAGE}&search=CITEC`));
            dispatch(getLabs(`?limit=100&page=${DEFAULT_PAGE}&search=CITEC`));
            applyFiltersAndFetch(pageSizeCitec, citec);
        }
    }, [activeTab]);

    useEffect(() => {
        const labTypeId = activeTab === '1' ? citec : movil;
        const pageSize = activeTab === '1' ? pageSizeCitec : pageSizeMovil;
        applyFiltersAndFetch(pageSize, labTypeId);
    }, []);

    const { labs, loading, total, currentPage,
        coordinations, labareas, labRequestReportRois } = useSelector(state => ({
            labs: state.labsReducer.labs,
            loading: state.labRequestReportRoiReducer.loading,
            total: state.labRequestReportRoiReducer.total,
            currentPage: state.labRequestReportRoiReducer.currentPage,
            coordinations: state.coordinations.coordinations,
            labsegments: state.labSegments.labsegments,
            labareas: state.labAreas.labareas,
            users: state.usersReducer.users,
            labRequestReportRois: state.labRequestReportRoiReducer.labRequestReportRois,
    }));

    const onSearch = () => {
        const labTypeId = activeTab === '1' ? citec : movil;
        const pageSize = activeTab === '1' ? pageSizeCitec : pageSizeMovil;
        applyFiltersAndFetch(pageSize, labTypeId);
    };

    const onSearchChange = (value) => setServiceFilter(value.target.value);

    const buildQueryParams = ({ labArea, labType, coord, dateFilter, initialDate, endDate, service }) => {
        const params = new URLSearchParams();

        if (labArea) params.append('laboratoryArea', labArea);
        if (labType) params.append('laboratory', labType);
        if (coord) params.append('coordination', coord);

        if (initialDate && endDate) {
            const typeMap = {
                '1': 'request_date',
                '2': 'initial_date',
                '3': 'final_date'
            };
            const filterType = typeMap[dateFilter];
            if (filterType) {
                params.append('dateFilterType', filterType);
                params.append('initialDatedAt', initialDate);
                params.append('finalDatedAt', endDate);
            }
        }

        if (service) params.append('search', service);

        let stringParams = '&' + params.toString();
        if (stringParams.endsWith("&")) {
            stringParams = stringParams.slice(0, -1);
        }
        return stringParams;
    };

    const onDateFilterChange = (value) => {
        setDateFilter(value.target.value);
        setEndDate('');
        setInitialDate('');
    };

    const modalClose = () => setIsUpdate(false);

    const RegisterModalRespInfo = (values) => {
        const updVal = { ...values };
        dispatch(updateLabRequest(updVal));
        setTimeout(() => {
            const labTypeId = activeTab === '1' ? citec : movil;
            const pageSize = activeTab === '1' ? pageSizeCitec : pageSizeMovil;
            applyFiltersAndFetch(pageSize, labTypeId);
        }, 500);
    };

    const handlePageSizeChange = (newSize) => {
        if (activeTab === '1') {
          setPageSizeCitec(newSize);
        } else {
          setPageSizeMovil(newSize);
        }
    };
    

    const columns = React.useMemo(
        () => [
          {
            Header: 'Información General',
            width: '19%',
            Cell: ({ row }) => (
              <div>
                <div style={{fontSize:12}}><b>Solicitud de Servicio No.: </b>{row.original?.code ?? '-'}</div>
                <div style={{fontSize:12}}><b>Cliente: </b>{ row.original?.customer?.name ?? '-'}</div>
                <div style={{fontSize:12}}><b>Coordinación: </b>{ row.original?.coordination?.name ?? '-'}</div>
                <div style={{fontSize:12}}><b>Área de Laboratorio: </b>{ row.original?.laboratoryArea?.name ?? '-'}</div>
                <div style={{fontSize:12}}><b>Tipo de Laboratorio: </b>{ row.original?.laboratoryArea?.laboratoryType?.name ?? '-'}</div>
                <div style={{fontSize:12}}><b>Laboratorio: </b>{ row.original?.laboratory?.name ?? '-'}</div>
              </div>

            ),
          },
          {
            Header: 'Descripción del Servicio',
            width: '15%',
            Cell: ({ row }) => (
              <div className='text-center'>
                <div style={{fontSize:12}}><b>REVGER:</b></div>
                <div style={{fontSize:12}}>{row.original?.revger ?? '-'}</div>
                <hr className='text-success m-2' style={{ height: 2 }} />
                <div style={{fontSize:12}}><b>Descripción del Servicio:</b></div>
                <div style={{fontSize:12}}>{row.original?.description ?? '-'}</div>
              </div>
            ),
          },
          {
            Header: 'Fechas de Solicitud',
            width: '18%',
            Cell: ({ row }) => (
              <div>
                <div className="d-flex justify-content-between mx-2">
                    <div  style={{fontSize:12}}>
                        <b>Fecha de solicitud:</b>
                    </div>
                    <div  style={{fontSize:12}}>
                        {moment.utc(row.original.createdAt).format('YYYY-MM-DD')}
                    </div>
                </div>
                <hr className='text-success m-2' style={{ height: 2 }} />
                <div className="d-flex justify-content-between mx-2">
                    <div  style={{fontSize:12}}>
                        <b>Fecha de recepción de muestras:</b>
                    </div>
                    <div  style={{fontSize:12}}>
                        { row.original.startedAt ? moment.utc(row.original.startedAt).format('YYYY-MM-DD') : '-' }
                    </div>
                </div>
                <hr className='text-success m-2' style={{ height: 2 }} />
                <div className="d-flex justify-content-between mx-2">
                    <div  style={{fontSize:12}}>
                        <b>Fecha de aceptación de solicitud:</b>
                    </div>
                    <div  style={{fontSize:12}}>
                    { row.original.endedAt ? moment.utc(row.original.endedAt).format('YYYY-MM-DD') : '-' }
                    </div>
                </div>
                <hr className='text-success m-2' style={{ height: 2 }} />
                <div className="d-flex justify-content-between mx-2">
                    <div  style={{fontSize:12}}>
                        <b>Días hábiles de servicio:</b>
                    </div>
                    <div  style={{fontSize:12}}>
                        { (row.original.startedAt && row.original.endedAt) ? getBusinessDateCountString( new Date(row.original.startedAt), new Date(row.original.endedAt)) : ''}
                    </div>
                </div>
                <hr className='text-success m-2' style={{ height: 2 }} />
                <div className="d-flex justify-content-between mx-2">
                    <div  style={{fontSize:12}}>
                        <b>Fecha de inicio de Ensayos:</b>
                    </div>
                    <div  style={{fontSize:12}}>
                    { row.original.labRequestReport[0]?.essaysStartedAt ? moment.utc(row.original?.labRequestReport[0]?.essaysStartedAt).format('YYYY-MM-DD') : '-' }
                    </div>
                </div>
                <hr className='text-success m-2' style={{ height: 2 }} />
                <div className="d-flex justify-content-between mx-2">
                    <div  style={{fontSize:12}}>
                        <b>Fecha de fin de ensayos:</b>
                    </div>
                    <div  style={{fontSize:12}}>
                    { row.original.labRequestReport[0]?.essaysEndedAt ? moment.utc(row.original?.labRequestReport[0]?.essaysEndedAt).format('YYYY-MM-DD') : '-' }
                    </div>
                </div>
                <hr className='text-success m-2' style={{ height: 2 }} />
                <div className="d-flex justify-content-between mx-2">
                    <div  style={{fontSize:12}}>
                        <b>Fecha de informe Final:</b>
                    </div>
                    <div  style={{fontSize:12}}>
                    { row.original.labRequestReport[0]?.endedAt ? moment.utc(row.original?.labRequestReport[0]?.endedAt).format('YYYY-MM-DD') : '-' }
                    </div>
                </div>
              </div>
            ),
          },
          {
            Header: 'Encuesta de solicitud',
            width: '18%',
            Cell: ({ row }) => (
              <div>
                <div className="d-flex justify-content-between mx-2">
                    <div  style={{fontSize:12}}>
                        Enviada a:
                    </div>
                    <div  style={{fontSize:12}}>
                        { `${row.original.technicalAdviser.name ?? '-'} ${row.original.technicalAdviser.surname ?? '-'}`}
                    </div>
                </div>
                <hr className='text-success m-2' style={{ height: 2 }} />
                <div className="d-flex justify-content-between mx-2">
                    <div  style={{fontSize:12}}>
                        Fecha de Envío:
                    </div>
                    <div  style={{fontSize:12}}>
                        { (row.original.labRequestSurvey[0]?.sendedAt) ? moment(row.original.labRequestSurvey[0]?.sendedAt).format('YYYY-MM-DD') : '-'}
                    </div>
                </div>
                <hr className='text-success m-2' style={{ height: 2 }} />
                <div className="d-flex justify-content-between mx-2">
                    <div  style={{fontSize:12}}>
                        Fecha de realizada:
                    </div>
                    <div  style={{fontSize:12}}>
                        { row.original.labRequestSurvey[0]?.performedAt ? moment(row.original.labRequestSurvey[0]?.performedAt).format('YYYY-MM-DD') : '-'}
                    </div>
                </div>
                <hr className='text-success m-2' style={{ height: 2 }} />
                <div className="d-flex justify-content-between mx-2">
                    <div  style={{fontSize:12}}>
                        Tiempo de contestación:
                    </div>
                    <div  style={{fontSize:12}}>
                        { (row.original.labRequestSurvey[0]?.sendedAt && row.original.labRequestSurvey[0]?.performedAt) ? `${diffDays(new Date(row.original.labRequestSurvey[0]?.performedAt), new Date(row.original.labRequestSurvey[0]?.sendedAt))} días` : '-' }
                    </div>
                </div>
                <hr className='text-success m-2' style={{ height: 2 }} />
              </div>
            ),
          },
          {
            Header: 'Estatus',
            width: "8%",
            Cell: ({ row }) => (
                row.original.requestStatus == 'Pendiente de envío' ?
                    <div className='text-warning'>Pendiente de envío</div> :
                    row.original.requestStatus == 'Aceptada' ?
                        <div className='text-success'>Aceptada</div> :
                        row.original.requestStatus == 'Rechazada' ?
                            <div className='text-danger'>Rechazada</div> :
                            row.original.requestStatus == 'Concluida' ?
                                <div className='text-success'>Concluida</div> :
                                row.original.requestStatus == 'En Espera' ?
                                    <div className='text-center' style={{color:'#1994EC'}} >En Espera</div> :
                                    row.original.requestStatus == 'Cancelada' ?
                                    <div className='text-danger'>Cancelada</div> : ''
            ),
          },
          {
            width: '6%',
            Header: "Acciones",
            Cell: ({ row }) => (
                <div className="page-title-box d-flex align-items-center justify-content-center row">
                    <div className='d-flex align-items-center justify-content-center mb-2'>
                        <BaseCustomButton
                            color="info"
                            label="Actualizar"
                            icon="mdi-18px mdi-lead-pencil"
                            outline
                            onClick={() => onUpdate(row.original)}
                            className="col-12"
                        />
                    </div>

                    <Link
                        to={{ pathname: `/results/${row.original?.id}` }}
                        className='d-flex align-items-center justify-content-center mb-2'
                        onClick={() => onEdit(row.original)}
                    >
                        <BaseCustomButton
                            color="primary"
                            label="Resumen"
                            outline
                            icon="mdi-18px mdi-bell-circle-outline"
                            className="col-12"
                        />
                    </Link>
            
                    <Link
                        to={{ pathname: `/labCitec/${row.original?.id}` }}
                        className='d-flex align-items-center justify-content-center mb-2'
                    >
                        <BaseCustomButton
                            color="success"
                            label="Detalles"
                            icon="mdi-18px mdi-launch"
                            outline
                            className="col-12"
                        />
                    </Link>
                </div>
            ),
          }          
        ],
        []
    )

    const onEdit = () => {}

    const onUpdate = (rowInfo) => {
        setRowInfo(rowInfo)
        setShowModal1(true)
    }

    const getPagination = (params) => {
        setParams2(params);
        dispatch(getLabRequestReportRois(`${params}&reportType=results&laboratoryType=${activeTab === '1' ? citec : movil}${filterQuery}`));
    };
      
    const exportURL = () => {
        const labTypeId = activeTab === '1' ? citec : movil;
        return `${baseUrl}lab-requests/report/export-to-excel${params2}&reportType=results&laboratoryType=${labTypeId}${filterQuery}`;
    };
      
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 20 }}>
                        <Card className='' style={{ padding: 40 }}>

                            <Breadcrumb breadcrumbItem1='results' />

                                <BackButton props={props} />

                                <Card className='' style={{ padding: 20 }}>

                                <div className='px-4 mx-3'>

                                    <Nav tabs className="nav-tabs-custom nav-justified">
                                        <NavItem >
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({ active: activeTab === '1' })}
                                                onClick={() => { profiletoggle('1'); }}
                                            >
                                                Servicios Laboratorio CITEC
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                style={{ cursor: "pointer" }}
                                                className={classnames({ active: activeTab === '2' })}
                                                onClick={() => { profiletoggle('2'); }}
                                            >
                                                Servicios Laboratorio Móvil
                                            </NavLink>
                                        </NavItem>
                                    </Nav>

                                    <TabContent activeTab={activeTab} className="px-0 py-4">

                                        <TabPane tabId='1'>
                                            <div className='d-flex align-items-start justify-content-start'>

                                                <div className="col-3 col-md-3 mx-2">
                                                    <label  className='text-primary ml-1'>Área de Laboratorio</label>
                                                    <select
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example"
                                                        defaultValue=""
                                                        value={labAreaFilter}
                                                        onChange={e => {
                                                            setLabAreaFilter(e.target.value)
                                                        }}
                                                    >
                                                        <option value="">Seleccione el área de laboratorio</option>
                                                        {labareas.map((dir, index) => {
                                                            return <option key={index} value={dir.id}>{dir.name}</option>
                                                        })}
                                                    </select>
                                                </div>

                                                <div className="col-3 col-md-3 mx-2">
                                                    <label  className='text-primary ml-1'>Laboratorio</label>
                                                    <select
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example"
                                                        defaultValue=""
                                                        value={labTypeFilter}
                                                        onChange={e => {
                                                            setLabTypeFilter(e.target.value)
                                                        }}
                                                    >
                                                        <option value="">Seleccione el tipo de laboratorio</option>
                                                        {labs.map((dir, index) => {
                                                            return <option key={index} value={dir.id}>{dir.name}</option>
                                                        })}
                                                    </select>
                                                </div>

                                                <div className="col-3 col-md-3 mx-2">
                                                    <label  className='text-primary ml-1'>Coordinación</label>
                                                    <select
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example"
                                                        defaultValue=""
                                                        value={coordFilter}
                                                        onChange={e => {
                                                            setCoordFiler(e.target.value)
                                                        }}
                                                    >
                                                        <option value="">Seleccione el tipo de coordinación</option>
                                                        {coordinations.map((dir, index) => {
                                                            return <option key={index} value={dir.id}>{dir.name}</option>
                                                        })}
                                                    </select>
                                                </div>

                                                <button type="submit"
                                                style={{ marginTop:30, maxHeight:40, marginLeft:15 }}
                                                className="btn btn-dark rounded-3 w-100"
                                                onClick={onSearch}>
                                                    <span className="mdi mdi-magnify me-2"></span>Buscar
                                                </button>
                                            </div>

                                            <div className='d-flex align-items-start justify-content-start mb-3'>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label htmlFor="exampleInputEmail" className='text-primary mt-3 rounded-3'>Tipo de Fecha</label>
                                                    <select onChange={onDateFilterChange}
                                                        value={dateFilter}
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example" >
                                                        <option defaultValue>Seleccionar Tipo de Fecha</option>
                                                        <option value="1">Fecha de Solicitud</option>
                                                        <option value="2">Fecha de inicio de trabajos</option>
                                                        <option value="3">Fecha de Informe final</option>
                                                    </select>
                                                </div>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label className='text-primary mt-3'>Fecha Inicio</label>
                                                    <Input
                                                        name="initialDate"
                                                        className="form-control rounded-3 text-primary"
                                                        type='date'
                                                        onChange={(e) => setInitialDate(e.target.value)}
                                                    />
                                                </div>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label className='text-primary mt-3'>Fecha Fin</label>
                                                    <Input
                                                        name="endDate"
                                                        className="form-control rounded-3 text-primary"
                                                        type='date'
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                    />
                                                </div>

                                                <Link className='btn rounded-3 w-100'
                                                    to={{ pathname: exportURL() }} target='_blank'
                                                >
                                                <button className='btn rounded-3 w-100' style={{ backgroundColor: 'green', color: 'white', marginTop:45, maxHeight:40, marginLeft:15}}>
                                                    <span className="mdi mdi-file-excel me-2"></span>Exportar Excel
                                                </button>
                                                </Link>

                                            </div>
                                            <div className='d-flex align-items-start justify-content-start mb-3'>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-12 col-xxl-12 mb-2 pe-2 ps-2">
                                                    <input type="search" value={serviceFilter} onChange={onSearchChange} className="form-control rounded-3 text-primary" placeholder="Servicio..." aria-label="Search" name='inputSearchData' />
                                                </div>
                                            </div>
                                            <div>
                                                <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={labRequestReportRois} onPageSizeChange={handlePageSizeChange} />
                                            </div>
                                        </TabPane>

                                        <TabPane tabId='2'>
                                            <div className='d-flex align-items-start justify-content-start'>
                                                <div className="col-3 col-md-3 mx-2">
                                                    <label  className='text-primary ml-1'>Área de Laboratorio</label>
                                                    <select
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example"
                                                        defaultValue=""
                                                        value={labAreaFilter}
                                                        onChange={e => {
                                                            setLabAreaFilter(e.target.value)
                                                        }}
                                                    >
                                                        <option value="">Seleccione el área de laboratorio</option>
                                                        {labareas.map((dir, index) => {
                                                            return <option key={index} value={dir.id}>{dir.name}</option>
                                                        })}
                                                    </select>
                                                </div>

                                                <div className="col-3 col-md-3 mx-2">
                                                    <label  className='text-primary ml-1'>Laboratorio</label>
                                                    <select
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example"
                                                        defaultValue=""
                                                        value={labTypeFilter}
                                                        onChange={e => {
                                                            setLabTypeFilter(e.target.value)
                                                        }}
                                                    >
                                                        <option value="">Seleccione el tipo de laboratorio</option>
                                                        {labs.map((dir, index) => {
                                                            return <option key={index} value={dir.id}>{dir.name}</option>
                                                        })}
                                                    </select>
                                                </div>

                                                <div className="col-3 col-md-3 mx-2">
                                                    <label  className='text-primary ml-1'>Coordinación</label>
                                                    <select
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example"
                                                        defaultValue=""
                                                        value={coordFilter}
                                                        onChange={e => {
                                                            setCoordFiler(e.target.value)
                                                        }}
                                                    >
                                                        <option value="">Seleccione el tipo de coordinación</option>
                                                        {coordinations.map((dir, index) => {
                                                            return <option key={index} value={dir.id}>{dir.name}</option>
                                                        })}
                                                    </select>
                                                </div>

                                                <button type="submit"
                                                style={{ marginTop:30, maxHeight:40, marginLeft:15 }}
                                                className="btn btn-dark rounded-3 w-100"
                                                onClick={onSearch}>
                                                    <span className="mdi mdi-magnify me-2"></span>Buscar
                                                </button>
                                            </div>

                                            <div className='d-flex align-items-start justify-content-start mb-3'>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label htmlFor="exampleInputEmail" className='text-primary mt-3 rounded-3'>Tipo de Fecha</label>
                                                    <select onChange={onDateFilterChange}
                                                        value={dateFilter}
                                                        className="form-select text-primary rounded-3"
                                                        aria-label="Default select example" >
                                                        <option defaultValue>Seleccionar Tipo de Fecha</option>
                                                        <option value="1">Fecha de Solicitud</option>
                                                        <option value="2">Fecha de inicio de trabajos</option>
                                                        <option value="3">Fecha de Informe final</option>
                                                    </select>
                                                </div>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label className='text-primary mt-3'>Fecha Inicio</label>
                                                    <Input
                                                        name="initialDate"
                                                        className="form-control rounded-3 text-primary"
                                                        type='date'
                                                        onChange={(e) => setInitialDate(e.target.value)}
                                                    />
                                                </div>

                                                <div className='col-3 col-md-3 mx-2'>
                                                    <label className='text-primary mt-3'>Fecha Fin</label>
                                                    <Input
                                                        name="endDate"
                                                        className="form-control rounded-3 text-primary"
                                                        type='date'
                                                        onChange={(e) => setEndDate(e.target.value)}
                                                    />
                                                </div>

                                                <Link className='btn rounded-3 w-100'
                                                        to={{ pathname: exportURL() }} target='_blank'
                                                >
                                                    <button className='btn rounded-3 w-100' style={{ backgroundColor: 'green', color: 'white', marginTop:45, maxHeight:40, marginLeft:15}}>
                                                        <span className="mdi mdi-file-excel me-2"></span>Exportar Excel
                                                    </button>
                                                </Link>

                                            </div>
                                            <div className='d-flex align-items-start justify-content-start mb-3'>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-12 col-xxl-12 mb-2 pe-2 ps-2">
                                                    <input type="search" value={serviceFilter} onChange={onSearchChange} className="form-control rounded-3 text-primary" placeholder="Servicio..." aria-label="Search" name='inputSearchData' />
                                                </div>
                                            </div>
                                            <div>
                                                <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={labRequestReportRois} onPageSizeChange={handlePageSizeChange} />
                                            </div>

                                        </TabPane>

                                    </TabContent>

                                    <UModal rowInfo={rowInfo} modalClose={modalClose} isUpdate={isUpdate} modalRespInfo={RegisterModalRespInfo} props={props} setShowModal={setShowModal1} showModal={showModal1} modalHeader='Registro/Actualización de Áreas de Laboratorio' />
                                </div>

                            <br />

                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                </Container>
            </div>
        </React.Fragment>
    )
}
